import {useEffect, useRef, useState} from "react";
import "./ConferencesSection.css";
import {useTheme} from "../../../hooks/useTheme";

import gridFrameMember2Light from "../../../assets/svg/our-team/tag-frame/grid-frame-member2-light.svg";
import gridFrameMember2Dark from "../../../assets/svg/our-team/tag-frame/grid-frame-member2-dark.svg";
// Same member2 nameTag artwork as TeamSlider, but with its baked-in fill
// recolored from the member2 light green (#E5FFE7) to cream (#FFFDF6) --
// see scripts/generate-conference-row-frame.js. Rendered inline (like
// Header's NavButtonLightIcon) instead of as a border-image: the fill
// already matches the row's intended background in each theme
// (#FFFDF6 == --bg light, #263327 == the dark active-row tint), so the
// whole card can be stretched full-bleed behind the row's own content
// instead of needing the border-image "no fill" 9-slice trick.
import {ReactComponent as EventRowFrameLightIcon} from "../../../assets/svg/our-team/tag-frame/member2-light-cream.svg";
import {ReactComponent as EventRowFrameDarkIcon} from "../../../assets/svg/our-team/tag-frame/member2-dark.svg";

// Інлайн-SVG контур треку замість border-image (той самий принцип, що й
// CustomScroll.jsx у Coverage) -- ці -vertical- файли вже самі по собі лише
// контур (stroke, fill="none"), тож заливку ховати не треба.
import {ReactComponent as ScrollTrackVerticalLightIcon} from "../../../assets/svg/cover-scroll-track-vertical-light.svg";
import {ReactComponent as ScrollTrackVerticalDarkIcon} from "../../../assets/svg/cover-scroll-track-vertical-dark.svg";

import img2022_1 from "../../../assets/conferences-imgs/2022/marbella/img1.JPG";
import img2022_2 from "../../../assets/conferences-imgs/2022/marbella/img2.JPG";

import img2023_1 from "../../../assets/conferences-imgs/2023/marbella/img1.JPG";
import img2023_2 from "../../../assets/conferences-imgs/2023/marbella/img2.png";
import img2023_3 from "../../../assets/conferences-imgs/2023/marbella/img3.JPG";

import img2024_bcn_1 from "../../../assets/conferences-imgs/2024/barcelona/img1.png";
import img2024_bcn_2 from "../../../assets/conferences-imgs/2024/barcelona/img2.png";
import img2024_mrb_1 from "../../../assets/conferences-imgs/2024/marbella/img1.JPG";

import img2025_1 from "../../../assets/conferences-imgs/2025/marbella/img1.png";
import img2025_2 from "../../../assets/conferences-imgs/2025/marbella/img2.png";
import img2025_3 from "../../../assets/conferences-imgs/2025/marbella/img3.JPG";
import img2025_4 from "../../../assets/conferences-imgs/2025/marbella/img4.JPG";

import img2026_bcn_1 from "../../../assets/conferences-imgs/2026/barcelona/img1.png";
import img2026_ftm_1 from "../../../assets/conferences-imgs/2026/future-tech-meetup-ai-first/img1.jpg";

// One row per conference (year + location), sorted by year descending --
// matches the mockup, where e.g. 2024 Barcelona and 2024 Marbella are two
// separate rows rather than merged under one "2024" entry.
const EVENTS = [
  {year: 2026, location: "Barcelona", photos: [img2026_bcn_1]},
  {year: 2026, location: "Future Tech Meetup AI First", photos: [img2026_ftm_1]},
  {year: 2025, location: "Marbella", photos: [img2025_1, img2025_2, img2025_3, img2025_4]},
  {year: 2024, location: "Barcelona", photos: [img2024_bcn_1, img2024_bcn_2]},
  {year: 2024, location: "Marbella", photos: [img2024_mrb_1]},
  {year: 2023, location: "Marbella", photos: [img2023_1, img2023_2, img2023_3]},
  {year: 2022, location: "Marbella", photos: [img2022_1, img2022_2]},
];

// Same arrow artwork as ProductExamples (ProductsSection.jsx), with the
// gradient/filter ids namespaced so both sections can be mounted at once.
function ArrowIcon({direction}) {
  const isBack = direction === "back";
  const filterId = `filter0_d_conf_${direction}`;
  const d = isBack
    ? "M1 29L1 13C1 9.8174 2.26428 6.76516 4.51472 4.51472C6.76516 2.26428 9.8174 1 13 0.999999L29 0.999999C32.1826 0.999999 35.2348 2.26428 37.4853 4.51472C39.7357 6.76515 41 9.8174 41 13L41 29C41 32.1826 39.7357 35.2348 37.4853 37.4853C35.2348 39.7357 32.1826 41 29 41L13 41C9.8174 41 6.76516 39.7357 4.51472 37.4853C2.26428 35.2348 1 32.1826 1 29ZM24.6667 27.6667C24.6677 27.4912 24.634 27.3172 24.5677 27.1548C24.5013 26.9923 24.4036 26.8446 24.28 26.72L18.5467 21L24.28 15.28C24.4043 15.1557 24.5029 15.0081 24.5702 14.8457C24.6375 14.6832 24.6721 14.5091 24.6721 14.3333C24.6721 14.1575 24.6375 13.9834 24.5702 13.821C24.5029 13.6586 24.4043 13.511 24.28 13.3867C24.1557 13.2623 24.0081 13.1637 23.8457 13.0965C23.6832 13.0292 23.5091 12.9945 23.3333 12.9945C23.1575 12.9945 22.9834 13.0292 22.821 13.0965C22.6586 13.1637 22.511 13.2623 22.3867 13.3867L15.72 20.0533C15.595 20.1773 15.4958 20.3248 15.4281 20.4872C15.3605 20.6497 15.3256 20.824 15.3256 21C15.3256 21.176 15.3605 21.3503 15.4281 21.5128C15.4958 21.6752 15.595 21.8227 15.72 21.9467L22.3867 28.6133C22.5106 28.7383 22.6581 28.8375 22.8206 28.9052C22.983 28.9729 23.1573 29.0077 23.3333 29.0077C23.5094 29.0077 23.6836 28.9729 23.8461 28.9052C24.0086 28.8375 24.156 28.7383 24.28 28.6133C24.4036 28.4887 24.5013 28.341 24.5677 28.1785C24.634 28.0161 24.6677 27.8421 24.6667 27.6667Z"
    : "M41 29L41 13C41 9.8174 39.7357 6.76516 37.4853 4.51472C35.2348 2.26428 32.1826 1 29 0.999999L13 0.999999C9.8174 0.999999 6.76515 2.26428 4.51472 4.51472C2.26428 6.76515 1 9.8174 0.999999 13L0.999999 29C0.999999 32.1826 2.26428 35.2348 4.51472 37.4853C6.76515 39.7357 9.8174 41 13 41L29 41C32.1826 41 35.2348 39.7357 37.4853 37.4853C39.7357 35.2348 41 32.1826 41 29ZM17.3333 27.6667C17.3323 27.4912 17.366 27.3172 17.4323 27.1548C17.4987 26.9923 17.5964 26.8446 17.72 26.72L23.4533 21L17.72 15.28C17.5957 15.1557 17.4971 15.0081 17.4298 14.8457C17.3625 14.6832 17.3279 14.5091 17.3279 14.3333C17.3279 14.1575 17.3625 13.9834 17.4298 13.821C17.4971 13.6586 17.5957 13.511 17.72 13.3867C17.8443 13.2623 17.9919 13.1637 18.1543 13.0965C18.3168 13.0292 18.4909 12.9945 18.6667 12.9945C18.8425 12.9945 19.0166 13.0292 19.179 13.0965C19.3414 13.1637 19.489 13.2623 19.6133 13.3867L26.28 20.0533C26.405 20.1773 26.5042 20.3248 26.5719 20.4872C26.6395 20.6497 26.6744 20.824 26.6744 21C26.6744 21.176 26.6395 21.3503 26.5719 21.5128C26.5042 21.6752 26.405 21.8227 26.28 21.9467L19.6133 28.6133C19.4894 28.7383 19.3419 28.8375 19.1794 28.9052C19.017 28.9729 18.8427 29.0077 18.6667 29.0077C18.4906 29.0077 18.3164 28.9729 18.1539 28.9052C17.9914 28.8375 17.844 28.7383 17.72 28.6133C17.5964 28.4887 17.4987 28.341 17.4323 28.1785C17.366 28.0161 17.3323 27.8421 17.3333 27.6667Z";

  return (
    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter={`url(#${filterId})`}>
        <path d={d} fill="#BFFFC2"/>
        <path d={d} stroke="#1A1A1A" strokeWidth="2"/>
      </g>
      <defs>
        <filter id={filterId} x="0" y="0" width="47" height="47" filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"/>
          <feOffset dx="5" dy="5"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result={`effect1_dropShadow_${filterId}`}/>
          <feBlend mode="normal" in="SourceGraphic" in2={`effect1_dropShadow_${filterId}`} result="shape"/>
        </filter>
      </defs>
    </svg>
  );
}

const MIN_SCROLL_THUMB = 24;

export default function ConferencesSection() {
  useTheme(); // theme drives the CSS (html[data-theme]) that picks the frame variables below

  const [eventIdx, setEventIdx] = useState(0);
  const [photoIdx, setPhotoIdx] = useState(0);

  // Vertical scroll indicator for the event list: same look as Coverage's
  // .scroll-track/.scroll-progress (CustomScroll.jsx), rotated vertical, but
  // with no drag/pointer handlers and no «/» buttons -- .conf-listWrap
  // scrolls the normal, native way (wheel/trackpad/touch/keyboard); this
  // effect only reads that native scroll position to size and place the
  // thumb, it never drives the scrolling itself.
  const listRef = useRef(null);
  const trackRef = useRef(null);
  const [scrollThumb, setScrollThumb] = useState({height: 0, top: 0});

  useEffect(() => {
    const list = listRef.current;
    const track = trackRef.current;
    if (!list || !track) return;

    const updateThumb = () => {
      const trackHeight = track.clientHeight;
      const maxScroll = list.scrollHeight - list.clientHeight;
      const thumbHeight = Math.min(
        trackHeight,
        Math.max(MIN_SCROLL_THUMB, (list.clientHeight / list.scrollHeight) * trackHeight)
      );
      const maxThumbOffset = trackHeight - thumbHeight;
      // iOS Safari's rubber-band overscroll pushes scrollTop past [0, maxScroll]
      // for an instant, which without clamping threw the thumb outside the
      // track (a visible jump) during that bounce.
      const clampedScrollTop = Math.min(Math.max(list.scrollTop, 0), maxScroll);
      const top = maxScroll > 0 ? (clampedScrollTop / maxScroll) * maxThumbOffset : 0;
      setScrollThumb({height: thumbHeight, top});
    };

    // iOS Safari dispatches "scroll" in sparse, uneven bursts during momentum
    // scrolling even though scrollTop itself is updated every frame -- driving
    // updateThumb() straight off that event (as on desktop, where events do
    // arrive every frame) made the thumb visibly lurch instead of tracking
    // smoothly. While a scroll is in progress, this instead re-samples the
    // live scrollTop every animation frame and only relies on "scroll" to
    // know when to start/keep that loop running, stopping it shortly after
    // events stop arriving so it isn't polling forever at rest.
    let frameId = null;
    let idleTimer = null;

    const tick = () => {
      updateThumb();
      frameId = requestAnimationFrame(tick);
    };

    const handleScroll = () => {
      if (frameId === null) {
        frameId = requestAnimationFrame(tick);
      }
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        cancelAnimationFrame(frameId);
        frameId = null;
      }, 150);
    };

    list.addEventListener("scroll", handleScroll, {passive: true});
    window.addEventListener("resize", updateThumb);
    const ro = new ResizeObserver(updateThumb);
    ro.observe(list);
    ro.observe(track);
    updateThumb();

    return () => {
      list.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateThumb);
      ro.disconnect();
      if (frameId !== null) cancelAnimationFrame(frameId);
      clearTimeout(idleTimer);
    };
  }, []);

  // Keeps the active thumbnail fully in view inside .conf-photoRow's own
  // horizontal scroll whenever it changes -- whether that's from clicking a
  // partially-visible thumbnail directly, or from the prev/next arrows
  // landing on one that's off to the side. "nearest" is what makes this a
  // no-op when the thumbnail is already fully visible, and it only scrolls
  // .conf-photoRow (the nearest scrollable ancestor on that axis), not the
  // list's own vertical scroll -- except on mount: nothing of the section is
  // in the viewport yet at that point (it sits far down the page), so
  // "nearest" isn't a no-op there, it scrolls the whole page down to reveal
  // the element.
  //
  // Skipping needs to compare the actual (eventIdx, photoIdx) values rather
  // than just "has this effect run before": React.StrictMode (index.js)
  // double-invokes effects on mount in dev, and a plain boolean ref flips
  // false on that first synthetic pass, so the second one already reads it
  // as false and fires the real scrollIntoView anyway -- refs survive
  // StrictMode's synthetic remount, a run-once flag doesn't. Comparing
  // values instead works because both synthetic passes see the same
  // (0, 0), so the second one correctly reads that as "no real change".
  const activeThumbRef = useRef(null);
  const lastSelectionRef = useRef(null);

  useEffect(() => {
    const selection = `${eventIdx}-${photoIdx}`;
    const isRealChange = lastSelectionRef.current !== null && lastSelectionRef.current !== selection;
    lastSelectionRef.current = selection;

    if (!isRealChange) return;

    activeThumbRef.current?.scrollIntoView({
      behavior: "smooth",
      inline: "nearest",
      block: "nearest",
    });
  }, [eventIdx, photoIdx]);

  const activeEvent = EVENTS[eventIdx];
  const mainPhoto = activeEvent.photos[photoIdx];

  const selectPhoto = (ei, pi) => {
    setEventIdx(ei);
    setPhotoIdx(pi);
  };

  const goPrev = () => {
    setPhotoIdx((i) => (i - 1 + activeEvent.photos.length) % activeEvent.photos.length);
  };

  const goNext = () => {
    setPhotoIdx((i) => (i + 1) % activeEvent.photos.length);
  };

  // grid-frame-member2 (memberThumb) drives the main-photo frame and the
  // matching frame on the active list thumbnail; member2 (nameTag) drives
  // the frame around the currently active event's whole row.
  const frameVars = {
    "--conf-photo-frame-light": `url(${gridFrameMember2Light})`,
    "--conf-photo-frame-dark": `url(${gridFrameMember2Dark})`,
  };

  return (
    <section className="conferences" style={frameVars}>
      <h2 className="title">Conferences</h2>

      <div className="conf-body">
        <div className="conf-main">
          <div className="conf-mainFrame">
            <img key={`${eventIdx}-${photoIdx}`}
                 className="conf-mainImg"
                 src={mainPhoto}
                 alt={`Vassabi conference, ${activeEvent.location} ${activeEvent.year}`}/>
          </div>

          {activeEvent.photos.length > 1 && (
            <div className="conf-arrows">
              <button className="conf-arrow"
                      onClick={goPrev}
                      aria-label="Previous photo">
                <ArrowIcon direction="back"/>
              </button>
              <button className="conf-arrow"
                      onClick={goNext}
                      aria-label="Next photo">
                <ArrowIcon direction="forward"/>
              </button>
            </div>
          )}
        </div>

        <div className="conf-listOuter">
          <div className="conf-listWrap" ref={listRef}>
            <div className="conf-list">
              {EVENTS.map((ev, ei) => {
                const isActiveEvent = ei === eventIdx;

                return (
                  <div key={`${ev.year}-${ev.location}`}
                       className={`conf-eventRow ${isActiveEvent ? "active" : ""}`}>
                    {isActiveEvent && (
                      <>
                        <EventRowFrameLightIcon
                          className="conf-eventRow-bg conf-eventRow-bg-light"
                          preserveAspectRatio="none"
                          aria-hidden="true"
                          focusable="false"
                        />
                        <EventRowFrameDarkIcon
                          className="conf-eventRow-bg conf-eventRow-bg-dark"
                          preserveAspectRatio="none"
                          aria-hidden="true"
                          focusable="false"
                        />
                      </>
                    )}
                    <div className="conf-eventHeader">
                      <span className="conf-eventName">{ev.location}</span>
                      <span className="conf-eventYear">{ev.year}</span>
                    </div>

                    <div className="conf-photoRow">
                      {ev.photos.map((photo, pi) => {
                        const isActive = isActiveEvent && pi === photoIdx;
                        return (
                          <button
                            key={pi}
                            ref={isActive ? activeThumbRef : null}
                            className={`conf-photoThumb ${isActive ? "active" : ""}`}
                            onClick={() => selectPhoto(ei, pi)}
                            aria-label={`${ev.location} ${ev.year}, photo ${pi + 1}`}
                          >
                            <img className="conf-photoThumbImg" src={photo}
                                 alt={`${ev.location}, ${ev.year}, photo ${pi + 1}`}/>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="conf-scrollTrack"
               ref={trackRef}>
            <ScrollTrackVerticalLightIcon
              className="conf-scrollTrack-bg conf-scrollTrack-bg-light"
              preserveAspectRatio="none"
              aria-hidden="true"
              focusable="false"
            />
            <ScrollTrackVerticalDarkIcon
              className="conf-scrollTrack-bg conf-scrollTrack-bg-dark"
              preserveAspectRatio="none"
              aria-hidden="true"
              focusable="false"
            />

            <div className="conf-scrollThumb"
                 style={{
                   height: scrollThumb.height + "px",
                   transform: `translateY(${scrollThumb.top}px)`,
                 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}